import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField } from '@mui/material';

import { useAppDispatch } from '@/redux/hooks';
import { IngestFile } from '@/redux/slices/slice_types';
import { getData } from '@/redux/slices/dataTableSlice';
import axios from '@/_utils/axios';
import { useToast } from '@/components/_common/Toast';
import { Dialog } from '@/components/_common';

type EditIngestFileDialogProps = {
  isOpen: boolean;
  ingestFile: IngestFile;
  onCancel: () => void;
};

const FormSchema = Yup.object().shape({
  fileName: Yup.string().required('File Name is required')
});

const EditIngestFileDialog = ({ isOpen, ingestFile, onCancel }: EditIngestFileDialogProps) => {
  const dispatch = useAppDispatch();
  const { error: errorToast } = useToast();
  const { values, errors, dirty, isSubmitting, resetForm, handleChange, handleSubmit } = useFormik({
    initialValues: { fileName: ingestFile.filename },
    validationSchema: FormSchema,
    onSubmit: async (values: { fileName: string }) => {
      try {
        const prefix = ingestFile.file_path.split('/').slice(0, -1).join('/');
        await axios.post(`/ingest_manager/ingest_records/${ingestFile.id}/rename/`, {
          file_path: `${prefix}/${values.fileName}`
        });
        dispatch(getData());
      } catch (error) {
        console.error('Failed to update ingest file name', error);
        errorToast('Failed to update ingest file name');
      } finally {
        onCancel();
      }
    }
  });

  const handleCancel = () => {
    resetForm();
    onCancel();
  };

  return (
    <Dialog
      showX
      title="Edit File Ingest"
      open={isOpen}
      onCancel={handleCancel}
      onSubmit={handleSubmit}
      cancelText="Close"
      submitText="Update"
      buttonColor="primary"
      loading={isSubmitting}
      isSubmitDisabled={!dirty || (dirty && Boolean(errors?.fileName))}
    >
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="File Name"
          name="fileName"
          value={values.fileName}
          error={dirty && Boolean(errors.fileName)}
          helperText={dirty && errors.fileName}
          onChange={handleChange}
        />
      </form>
    </Dialog>
  );
};

export default EditIngestFileDialog;
